import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop } from '@material-ui/core';
import Loader from 'components/Loading/Loader';


const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    flexDirection: 'column',
    color: '#103a99',
    background: 'rgba(256, 256, 256, 0.5)',
  },
  absolute: {
    position: 'absolute'
  }
}));

const BackdropCircular = ({ loading, title = '', local = false }) => {
  const classes = useStyles();
  return (
    <Backdrop
      data-testid="backdrop-circular"
      className={`${classes.backdrop} ${local ? classes.absolute : ''}`}
      open={loading}
    >
      <p>{title}</p>
      <Loader />
    </Backdrop>
  );
};

export default BackdropCircular;
